module.exports = __webpack_public_path__ + "static/media/microphone~MMbrAzIj.6923d8d0.svg";